export const LSpanColumnMidRanges = {
  disruptive: {
    min: 57,
    max: 68,
  },
  pragmatic: {
    min: 43,
    max: 54,
  },
  measured: {
    min: 48,
    max: 57,
  },
  heroic: {
    min: 54,
    max: 63,
  },
  vulnerable: {
    min: 54,
    max: 66,
  },
  galvanizing: {
    min: 53,
    max: 66,
  },
  connecting: {
    min: 57,
    max: 69,
  },
  risk_taking: {
    min: 59,
    max: 69,
  },
} as const;

export type LSpanKey = keyof typeof LSpanColumnMidRanges;

export const getBucketFromScore = (
  score: number | undefined,
  key: LSpanKey
) => {
  const { min, max } = LSpanColumnMidRanges[key];
  if (!score) return 0;
  return score < min ? 1 : score > max ? 3 : 2;
};
